import { Link } from "react-router-dom";
import { FileText, ScrollText, Phone, Hospital, AlertTriangle, Scale } from "lucide-react";
import SEO from "../components/SEO";
import CTASection from "../components/sections/CTASection";

const RESOURCES = [
  {
    icon: ScrollText, title: "Ohio Statute of Limitations",
    desc: "2 years for personal injury in most cases. Different rules apply to medical malpractice, dog bites, and government claims.",
    link: "/blog/ohio-statute-of-limitations-personal-injury",
  },
  {
    icon: AlertTriangle, title: "What to Do After an Accident",
    desc: "A step-by-step guide for the first 48 hours after any Ohio accident. The most important checklist you'll read.",
    link: "/blog/what-to-do-after-car-accident-ohio",
  },
  {
    icon: Scale, title: "Ohio Comparative Negligence",
    desc: "How Ohio's 51% rule works — and why insurance companies use it against you.",
    link: "/blog/ohio-comparative-negligence-law",
  },
  {
    icon: Phone, title: "Talking to Insurance",
    desc: "What to say (and not say) to insurance adjusters after an Ohio accident.",
    link: "/blog/should-i-talk-to-insurance-after-accident",
  },
  {
    icon: FileText, title: "Settlement Timelines",
    desc: "How long Ohio accident cases really take and what affects speed.",
    link: "/blog/average-settlement-timeline-ohio",
  },
  {
    icon: Hospital, title: "Uninsured Motorist Guide",
    desc: "What happens when the at-fault driver has no insurance — and how UM coverage protects you.",
    link: "/blog/uninsured-motorist-coverage-ohio",
  },
];

export default function Resources() {
  return (
    <>
      <SEO title="Ohio Accident Resources | Free Guides & Information" description="Free Ohio accident resources, guides, and legal information for victims." />
      <section className="pt-12 md:pt-20 pb-12 px-6 bg-bone">
        <div className="max-w-7xl mx-auto">
          <div className="overline mb-3">Resource Hub</div>
          <h1 className="text-4xl md:text-6xl font-display font-bold text-forest tracking-tight mb-5 text-balance max-w-3xl">
            Free Ohio accident resources, guides, and answers.
          </h1>
          <p className="text-lg text-charcoal-soft max-w-2xl">
            Everything we wish every Ohio accident victim knew, in one place.
          </p>
        </div>
      </section>

      <section className="px-6 pb-20">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {RESOURCES.map((r, i) => (
            <Link key={i} to={r.link} className="card-elevated p-7 group" data-testid={`resource-card-${i}`}>
              <div className="w-11 h-11 rounded-xl bg-terracotta/10 text-terracotta grid place-items-center mb-4">
                <r.icon className="w-5 h-5" />
              </div>
              <h3 className="font-display font-bold text-xl text-forest mb-2 leading-tight group-hover:text-terracotta transition-colors">
                {r.title}
              </h3>
              <p className="text-sm text-charcoal-soft leading-relaxed">{r.desc}</p>
            </Link>
          ))}
        </div>
      </section>
      <CTASection />
    </>
  );
}
